import CurrencyIcon from './icons/currency-icon.svelte';
import AllGamesTabIcon from './parts/all-games-tab-icon.svelte';
import ArrowIcon from './parts/arrow-icon.svelte';
import CashbackIcon from './parts/cashback-icon.svelte';
import CasinoIcon from './parts/casino-icon.svelte';
import CCIcon from './parts/cc-icon.svelte';
import ChatIcon from './parts/chat-icon.svelte';
import ChatsIcon from './parts/chats-icon.svelte';
import CheckIcon from './parts/check-icon.svelte';
import ClockIcon from './parts/clock-icon.svelte';
import CloseIcon from './parts/close-icon.svelte';
import CopyIcon from './parts/copy-icon.svelte';
import DiscordIcon from './parts/discord-icon.svelte';
import DropdownArrowIcon from './parts/dropdown-arrow-icon.svelte';
import DropdownIcon from './parts/dropdown-icon.svelte';
import ElitePerksIcon from './parts/elite-perks-icon.svelte';
import EmailIcon from './parts/email-icon.svelte';
import ErrorIcon from './parts/error-icon.svelte';
import EventsIcon from './parts/events-icon.svelte';
import EventsPartyIcon from './parts/events-party-icon.svelte';
import EventsTicketsIcon from './parts/events-tickets-icon.svelte';
import EyeIcon from './parts/eye-icon.svelte';
import EyeSlashIcon from './parts/eye-slash-icon.svelte';
import FacebookIcon from './parts/facebook-icon.svelte';
import FavoritesTabIcon from './parts/favorites-tab-icon.svelte';
import FavouriteIcon from './parts/favourite.svelte';
import FeatureBuyInIcon from './parts/feature-buy-in-icon.svelte';
import FeatureBuyInTabIcon from './parts/feature-buy-in-tab-icon.svelte';
import FlushVIPClubIcon from './parts/flush-vipclub-icon.svelte';
import FreeSpinsIcon from './parts/free-spins-icon.svelte';
import GameShowsIcon from './parts/game-shows-icon.svelte';
import GameShowsTabIcon from './parts/game-shows-tab-icon.svelte';
import GifIcon from './parts/gif-icon.svelte';
import GiftFlatNeutralIcon from './parts/gift-flat-neutral-icon.svelte';
import GiftIcon from './parts/gift-icon.svelte';
import GoBackIcon from './parts/go-back-icon.svelte';
import GoogleIcon from './parts/google-icon.svelte';
import HappyFaceIcon from './parts/happy-face-icon.svelte';
import HomeIcon from './icons/home.svelte';
import IconPicker from './parts/icon-picker.svelte';
import IncorrectIcon from './parts/incorrect-icon.svelte';
import InfoIcon from './parts/info-icon.svelte';
import InstagramIcon from './parts/instagram-icon.svelte';
import InteractIcon from './parts/interact-icon.svelte';
import LeftIcon from './parts/left-icon.svelte';
import LikeIcon from './parts/like.svelte';
import LinkIcon from './parts/link-icon.svelte';
import LiveCasinoIcon from './parts/live-casino-icon.svelte';
import LiveCasinoTabIcon from './parts/live-casino-tab-icon.svelte';
import LockIcon from './parts/lock-icon.svelte';
import MailIcon from './parts/mail-icon.svelte';
import MediaContentIcon from './parts/media-content-icon.svelte';
import MediaContentUploadIcon from './parts/media-content-upload-icon.svelte';
import MetaMaskIcon from './parts/meta-mask-icon.svelte';
import NewGamesIcon from './parts/new-games-icon.svelte';
import NewGamesTabIcon from './parts/new-games-tab-icon.svelte';
import NextPaginatorIcon from './parts/next-paginator-icon.svelte';
import NotificationsIcon from './parts/notifications-icon.svelte';
import OptionsIcon from './parts/options-icon.svelte';
import OriginalsIcon from './parts/originals-icon.svelte';
import OriginalsTabIcon from './parts/originals-tab-icon.svelte';
import PlayIcon from './parts/play-icon.svelte';
import PopularIcon from './parts/popular-icon.svelte';
import PopularTabIcon from './parts/popular-tab-icon.svelte';
import PreviousPaginatorIcon from './parts/previous-paginator-icon.svelte';
import PromotionsIcon from './parts/promotions-icon.svelte';
import ProviderIcon from './parts/provider-icon.svelte';
import QuestIcon from './parts/quest-icon.svelte';
import QuestionIcon from './parts/question-icon.svelte';
import RacesIcon from './parts/races-icon.svelte';
import ReadIcon from './parts/read-icon.svelte';
import RecentlyTabIcon from './parts/recently-tab-icon.svelte';
import RedditIcon from './parts/reddit-icon.svelte';
import RefreshIcon from './parts/refresh-icon.svelte';
import RemoteIcon from './parts/remote-icon.svelte';
import RemoveIcon from './parts/remove-icon.svelte';
import RightIcon from './parts/right-icon.svelte';
import SaveIcon from './parts/save-icon.svelte';
import ScrollUpIcon from './parts/scroll-up-icon.svelte';
import SearchIcon from './parts/search-icon.svelte';
import ShareIcon from './parts/share-icon.svelte';
import SidebarSportsIcon from './parts/sidebar-sports-icon.svelte';
import SlotsIcon from './parts/slots-icon.svelte';
import SlotsTabIcon from './parts/slots-tab-icon.svelte';
import SpinIcon from './parts/spin-icon.svelte';
import SportsIcon from './parts/sports-icon.svelte';
import StarIcon from './parts/star-icon.svelte';
import SuccessIcon from './parts/success-icon.svelte';
import SupportChatArticleDepositIcon from './parts/support-chat-article-deposit-icon.svelte';
import SupportChatArticleVerificationIcon from './parts/support-chat-article-verification-icon.svelte';
import SupportChatArticleWithdrawIcon from './parts/support-chat-article-withdraw-icon.svelte';
import SupportChatHelpIcon from './parts/support-chat-help-icon.svelte';
import SupportChatHomeIcon from './parts/support-chat-home-icon.svelte';
import SupportChatMessagesIcon from './parts/support-chat-messages-icon.svelte';
import SupportChatSendIcon from './parts/support-chat-send-icon.svelte';
import SupportIcon from './parts/support-icon.svelte';
import SwitchIcon from './parts/switch-icon.svelte';
import TelegramIcon from './parts/telegram-icon.svelte';
import TestimonialsIcon from './parts/testimonials-icon.svelte';
import TickIconAlternative from './parts/tick-icon-alternative.svelte';
import TickIcon from './parts/tick-icon.svelte';
import TradingIcon from './parts/trading-icon.svelte';
import TrashIcon from './parts/trash-icon.svelte';
import UnlockIcon from './parts/unlock-icon.svelte';
import UpIcon from './parts/up-icon.svelte';
import UpdownGame from './parts/updown-game-icon.svelte';
import Usdt02Icon from './parts/usdt02-icon.svelte';
import UserIcon from './parts/user-icon.svelte';
import VipHeaderIcon from './parts/vip-header-icon.svelte';
import VipIcon from './parts/vip-icon.svelte';
import WalletConnectIcon from './parts/wallet-connect-icon.svelte';
import WalletGameIcon from './parts/wallet-game-icon.svelte';
import WalletFlatNeutralIcon from './parts/wallet-flat-neutral-icon.svelte';
import WalletIcon from './parts/wallet-icon.svelte';
import WalletMobileIcon from './parts/wallet-mobile-icon.svelte';
import Wallet02Icon from './parts/wallet02-icon.svelte';
import WarningIcon from './parts/warning-icon.svelte';
import WarningNewIcon from './parts/warning-new-icon.svelte';
import WarningSmallIcon from './parts/warning-small-icon.svelte';
import XIcon from './parts/x-icon.svelte';
import YoutubeIcon from './parts/youtube-icon.svelte';
// Comment Icons
import ArrowIconComment from './parts/arrow-icon-comment.svelte';
import ChatIconComment from './parts/chat-icon-comment.svelte';
import LikeIconComment from './parts/like-icon-comment.svelte';
import ReplyIconComment from './parts/reply-icon-comment.svelte';
import SimilarIconComment from './parts/similar-icon-comment.svelte';
import SmileIconComment from './parts/smile-icon-comment.svelte';
import LocalIcon from './parts/local-icon.svelte';
// Wallet Icons
export const GameIcons = {
    WalletIcon: WalletGameIcon
};
// Tab Icons
export const TabIcons = {
    FeatureBuyInIcon: FeatureBuyInTabIcon,
    GameShowsIcon: GameShowsTabIcon,
    LiveCasinoIcon: LiveCasinoTabIcon,
    NewGamesIcon: NewGamesTabIcon,
    OriginalsIcon: OriginalsTabIcon,
    PopularIcon: PopularTabIcon,
    AllGamesIcon: AllGamesTabIcon,
    FavoritesIcon: FavoritesTabIcon,
    RecentlyIcon: RecentlyTabIcon,
    SlotsIcon: SlotsTabIcon
};
// Header Icons
export const HeaderIcons = {
    VipIcon: VipHeaderIcon
};
// Sidebar Icons
export const SidebarIcons = {
    SportsIcon: SidebarSportsIcon
};
// Default Icons
export { ArrowIcon, ArrowIconComment, CashbackIcon, CasinoIcon, CCIcon, ChatIcon, ChatIconComment, ChatsIcon, CheckIcon, ClockIcon, CloseIcon, CopyIcon, CurrencyIcon, DiscordIcon, DropdownArrowIcon, DropdownIcon, ElitePerksIcon, EmailIcon, ErrorIcon, EventsIcon, EventsPartyIcon, EventsTicketsIcon, EyeIcon, EyeSlashIcon, FacebookIcon, FavouriteIcon, FeatureBuyInIcon, FeatureBuyInTabIcon, FlushVIPClubIcon, FreeSpinsIcon, GameShowsIcon, GameShowsTabIcon, GifIcon, GiftFlatNeutralIcon, GiftIcon, GoBackIcon, GoogleIcon, HappyFaceIcon, HomeIcon, IconPicker, IncorrectIcon, InfoIcon, InstagramIcon, InteractIcon, LeftIcon, LikeIcon, LikeIconComment, LinkIcon, LiveCasinoIcon, LiveCasinoTabIcon, LocalIcon, LockIcon, MailIcon, MediaContentIcon, MediaContentUploadIcon, MetaMaskIcon, NewGamesIcon, NewGamesTabIcon, NextPaginatorIcon, NotificationsIcon, OptionsIcon, OriginalsIcon, OriginalsTabIcon, PlayIcon, PopularIcon, PopularTabIcon, PreviousPaginatorIcon, PromotionsIcon, ProviderIcon, QuestIcon, QuestionIcon, RacesIcon, ReadIcon, RecentlyTabIcon, RedditIcon, RefreshIcon, RemoteIcon, RemoveIcon, ReplyIconComment, RightIcon, SaveIcon, ScrollUpIcon, SearchIcon, ShareIcon, SidebarSportsIcon, SimilarIconComment, SlotsIcon, SlotsTabIcon, SmileIconComment, SpinIcon, SportsIcon, StarIcon, SuccessIcon, SupportChatArticleDepositIcon, SupportChatArticleVerificationIcon, SupportChatArticleWithdrawIcon, SupportChatHelpIcon, SupportChatHomeIcon, SupportChatMessagesIcon, SupportChatSendIcon, SupportIcon, SwitchIcon, TelegramIcon, TestimonialsIcon, TickIcon, TickIconAlternative, TradingIcon, TrashIcon, UnlockIcon, UpdownGame, UpIcon, Usdt02Icon, UserIcon, VipIcon, Wallet02Icon, WalletConnectIcon, WalletFlatNeutralIcon, WalletIcon, WalletMobileIcon, WarningIcon, WarningNewIcon, WarningSmallIcon, XIcon, YoutubeIcon };
